module.exports = __webpack_public_path__ + "img/33.94219409.png";